import React, { useEffect, useState, useRef } from "react";
import AgoraRTC, {
  createClient,
  createCameraVideoTrack,
  createMicrophoneAudioTrack,
} from "agora-rtc-sdk-ng";
import AgoraRTM from "agora-rtm-sdk";
import { Styles } from "./styles";
import { errorToaster } from "../../helpers/toasterConfiguration";
import Loader from "../../components/common/loader/Loader";
import {
  joinActivity,
  joinSession,
  joinSession2,
} from "../../services/agora.service";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Join from "../../components/bbbTest/join/Join";
import { getAllLessons } from "../../services/courses.service";
import Metting from "../../components/bbbTest/metting/Metting";
import { getAllActivities } from "../../services/activities.service";
import BigBlueButtonMeeting from "../../components/bbbTest/metting/BigBlueButtonMeeting";
import SiteNavbar from "../../components/navbar/SiteNavbar";

const client = createClient({
  mode: "rtc",
  codec: "vp8",
});

let audioTrack;
let videoTrack;
let screenShareTrack;
let stream;
let signalingEngine = null;
let channel = null;

const BbbTest = () => {
  const { courseId, id } = useParams();

  const navigate = useNavigate();
  const location = useLocation();
  const isActivity = location.pathname.includes("/activity");
  const [isAudioOn, setIsAudioOn] = useState(false);
  const [isVideoOn, setIsVideoOn] = useState(false);
  const [isAudioPubed, setIsAudioPubed] = useState(false);
  const [isVideoPubed, setIsVideoPubed] = useState(false);
  const [isScreenVideoPubed, setIsScreenVideoPubed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [mutedUsers, setMutedUsers] = useState({});
  const [remoteUserTracks, setRemoteUserTracks] = useState([]);
  const [remoteUserAudioTracks, setRemoteUserAudioTracks] = useState([]);
  const [usersCount, setUsersCount] = useState(0);
  const [isJoined, setIsJoined] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const swiperRef = useRef(null);
  const [currentMainVideos, setCurrentMainVideos] = useState([]);
  const [allVideos, setAllVideos] = useState([]);
  const [joinedUsersWithNoPublish, setJoinedUsersWithNoPublish] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState();
  const [indexToRemove, setIndexToRemove] = useState(0);
  const [canPublishVideo, setCanPublishVideo] = useState(true);
  const [canPublishAudio, setCanPublishAudio] = useState(true);
  const [TurnOnCameraLoading, setTurnOnCameraLoading] = useState(false);
  const [TurnOffCameraLoading, setTurnOffCameraLoading] = useState(false);
  const [TurnOnMicLoading, setTurnOnMicLoading] = useState(false);
  const [TurnOffMicLoading, setTurnOffMicLoading] = useState(false);
  const [turnOnSahreScreenLoading, setTurnOnSahreScreenLoading] =
    useState(false);
  const [turnOffSahreScreenLoading, setTurnOffSahreScreenLoading] =
    useState(false);
  const [isAudience, setIsAudience] = useState(false);
  const [isHandRaised, setIsHandRaised] = useState(false);
  const [bigBlueButtonUrl, setBigBlueButtonUrl] = useState();

  const [config, setConfig] = useState({
    appId: null,
    rtcToken: null,
    channelName: null,
    rtmToken: null,
    userId: null,
    userName: null,
    avatar: null,
  });

  const [data, setData] = useState();
  const [isCourseDataLoading, setIsCourseDataLoading] = useState(false);

  const getLessonsData = async () => {
    setIsCourseDataLoading(true);
    const response = await getAllLessons(courseId);
    if (response?.status === 200) {
      const selectedLesson = response?.data?.data?.filter(
        (item) => item?.id === id
      );
      if (!selectedLesson[0]) {
        navigate("/error", { replace: true });
      }
      setData(selectedLesson[0]);
      setIsCourseDataLoading(false);
    } else {
      setIsCourseDataLoading(false);
      navigate("/error", { replace: true });
    }
  };

  const getActivityData = async () => {
    setIsCourseDataLoading(true);
    const requestParams = {
      searchBy: "id",
      searchText: id,
    };
    const response = await getAllActivities(requestParams);
    if (response?.status === 200) {
      if (!response?.data?.data?.list[0]) {
        navigate("/error", { replace: true });
      }
      setData(response?.data?.data?.list[0]);
      setIsCourseDataLoading(false);
    } else {
      setIsCourseDataLoading(false);
      navigate("/error", { replace: true });
    }
  };

  useEffect(() => {
    if (isActivity) {
      getActivityData();
    } else {
      getLessonsData();
    }
  }, []);

  const handleVideoClick = (index) => {
    const newMainVideos = [...currentMainVideos];
    newMainVideos[indexToRemove] = allVideos[index];
    if (indexToRemove === 0) {
      setIndexToRemove(1);
    } else if (indexToRemove === 1) {
      setIndexToRemove(2);
    } else {
      setIndexToRemove(0);
    }
    setCurrentMainVideos(newMainVideos);
  };

  // signalingEngine?.addEventListener("message", (event) => {
  //   console.log("object");
  //   console.log(event);
  //   if (
  //     event?.message == '"video-mute"' ||
  //     event?.message == '"share-screen-off"'
  //   ) {
  //     setCanPublishVideo(false);
  //     if (isVideoOn) {
  //       publishVideo();
  //     }
  //     if (screenShareTrack) {
  //       stopScreenShare();
  //     }
  //   }
  //   if (event?.message == '"audio-mute"') {
  //     setCanPublishAudio(false);
  //     if (isAudioOn) {
  //       publishAudio();
  //     }
  //   }
  //   if (event?.message == '"AllowCams"') {
  //     setCanPublishVideo(true);
  //   }
  //   if (event?.message == '"AllowMics"') {
  //     setCanPublishAudio(true);
  //   }
  // });

  const joinChannel = async () => {
    setIsLoading(true);
    let response;
    if (isActivity) {
      response = await joinActivity(id);
    } else {
      response = await joinSession(id);
    }
    if (response?.status === 200) {
      setConfig(response?.data?.data);
      if (isActivity) {
        setIsAudience(response?.data?.data?.isAudience);
      }
      if (response?.data?.data?.provider === "AG") {
        if (response?.data?.data?.appId && response?.data?.data?.channelName) {
          setIsLoading(true);
          try {
            signalingEngine = AgoraRTM.createInstance(
              response?.data?.data?.appId
            );
            const option = {
              uid: String(response?.data?.data?.userId),
              token: response?.data?.data?.rtmToken || null,
            };
            await signalingEngine.login(option);
            const userAttributes = {
              name: response?.data?.data?.userName,
              avatar: response?.data?.data?.avatar,
            };
            if (userAttributes?.name) {
              if (userAttributes?.avatar) {
                await signalingEngine.addOrUpdateLocalUserAttributes(
                  userAttributes
                );
              } else {
                await signalingEngine.addOrUpdateLocalUserAttributes({
                  name: userAttributes?.name,
                });
              }
            } else {
              if (userAttributes?.avatar) {
                await signalingEngine.addOrUpdateLocalUserAttributes({
                  avatar: userAttributes?.avatar,
                });
              }
            }
            channel = await signalingEngine.createChannel(
              response?.data?.data?.channelName
            );
            await channel.join();
            // signalingEngine = new AgoraRTM.RTM(
            //   response?.data?.data?.appId,
            //   String(response?.data?.data?.userId),
            //   {
            //     token: response?.data?.data?.rtmToken,
            //     useStringUserId: String(response?.data?.data?.userId),
            //     logUpload: false,
            //     presenceTimeout: 300,
            //   }
            // );
            // if (signalingEngine) {
            //   await signalingEngine.login();
            //   const subscribeOptions = {
            //     withMessage: true,
            //     withPresence: true,
            //     withMetadata: true,
            //     withLock: true,
            //   };
            //   await signalingEngine.subscribe(
            //     response?.data?.data?.channelName,
            //     subscribeOptions
            //   );
            //   await signalingEngine.storage.setUserMetadata(
            //     [
            //       {
            //         key: "userName",
            //         value: response?.data?.data?.userName,
            //       },
            //       {
            //         key: "avatar",
            //         value: response?.data?.data?.avatar,
            //       },
            //     ],
            //     {
            //       userId: String(response?.data?.data?.userId),
            //       addTimeStamp: true,
            //       addUserId: true,
            //     }
            //   );
            // }
            await client.join(
              response?.data?.data?.appId,
              response?.data?.data?.channelName,
              response?.data?.data?.rtcToken || null,
              response?.data?.data?.userId
            );

            setIsJoined(true);
            setIsLoading(false);
          } catch (error) {
            errorToaster("there was an error in data");
            setIsLoading(false);
          }
        } else {
          errorToaster("there was an error in data");
        }
      } else if (response?.data?.data?.provider === "BBB") {
        setIsJoined(true);
        setBigBlueButtonUrl(response?.data?.data?.meetingUrl);
      }
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  const publishVideo = async () => {
    if (screenShareTrack) {
      stopScreenShare();
    }
    if (isVideoOn) {
      setTurnOffCameraLoading(true);
      await turnOnCamera(false);
      setIsVideoPubed(false);
      setIsVideoOn(false);
      setTurnOffCameraLoading(false);
    } else {
      setTurnOnCameraLoading(true);
      await turnOnCamera(true);
      if (!isJoined) {
        await joinChannel();
      }
      try {
        await client.publish(videoTrack);
        setIsVideoPubed(true);
        setIsVideoOn(true);
      } catch (error) {
        await turnOnCamera(false);
        setIsVideoPubed(false);
        setIsVideoOn(false);
        errorToaster("Error publishing video track");
      }
      setTurnOnCameraLoading(false);
    }
  };

  const turnOnCamera = async (flag) => {
    try {
      setIsVideoOn(flag);
      if (flag) {
        videoTrack = await createCameraVideoTrack();
        videoTrack.setEnabled(true);
        videoTrack?.play("camera-video");
      } else {
        videoTrack.setEnabled(false);
        await client.unpublish(videoTrack);
        videoTrack = null;
      }
    } catch (error) {
      errorToaster("we can't use this cam");
      setIsVideoOn(false);
    }
  };

  const publishAudio = async () => {
    if (isAudioOn) {
      setTurnOffMicLoading(true);
      await turnOnMicrophone(false);
      setIsAudioPubed(false);
      setTurnOffMicLoading(false);
    } else {
      setTurnOnMicLoading(true);
      await turnOnMicrophone(true);
      if (!isJoined) {
        await joinChannel();
      }
      try {
        await client.publish(audioTrack);
        setIsAudioPubed(true);
      } catch (error) {
        await turnOnMicrophone(false);
        setIsAudioPubed(false);
        errorToaster("Error publishing audio track");
      }
      setTurnOnMicLoading(false);
    }
  };

  const turnOnMicrophone = async (flag) => {
    try {
      flag = flag && !isAudioOn;

      if (flag && !audioTrack) {
        audioTrack = await createMicrophoneAudioTrack();
      }

      setIsAudioOn(flag);

      if (audioTrack) {
        await audioTrack.setEnabled(flag);
      }
    } catch (error) {
      errorToaster("we can't use this microphone");
      setIsAudioOn(false);
    }
  };

  const leaveChannel = async () => {
    try {
      if (isAudioOn) {
        setIsAudioPubed(false);
        await client.unpublish(audioTrack);
        audioTrack.stop();
        audioTrack = null;
        turnOnMicrophone(false);
      }
      if (isVideoOn) {
        setIsVideoPubed(false);
        turnOnCamera(false);
      }
      if (screenShareTrack) {
        await stopScreenShare();
      }
      if (
        document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement
      ) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
        setIsFullScreen(false);
      }
      await channel.leave();
      await signalingEngine.logout();
      await client.leave();
      setRemoteUserTracks([]);
      setRemoteUserAudioTracks([]);
      setJoinedUsersWithNoPublish([]);
      setIsJoined(false);
    } catch (error) {
      setIsJoined(false);
      setRemoteUserTracks([]);
      setRemoteUserAudioTracks([]);
      setJoinedUsersWithNoPublish([]);
    }
  };

  const getUserMetadata = async function (uid) {
    try {
      const result = await signalingEngine?.getUserAttributes(uid);
      return result;
    } catch (error) {
      console.log(error);
    }
  };

  const onUserPublish = async (user, mediaType) => {
    if (mediaType === "video") {
      const remoteVideoTrack = await client?.subscribe(user, mediaType);
      if (remoteVideoTrack) {
        const metadata = await getUserMetadata(String(user?.uid));
        const userWithMetadata = {
          user: user,
          metadata: metadata,
          track: remoteVideoTrack,
        };
        setRemoteUserTracks((prevTracks) => [...prevTracks, userWithMetadata]);
        // setAllVideos((prevTracks) => [...prevTracks, userWithMetadata]);
        setJoinedUsersWithNoPublish((prevTracks) =>
          prevTracks?.filter((trackInfo) => trackInfo?.user?.uid !== user?.uid)
        );
        // if (
        //   document
        //     ?.getElementById("fullScreenVideo")
        //     ?.classList?.contains("fullscreen")
        // ) {
        //   toggleFullScreenVideo();
        //   setAllVideos((prevTracks) => [selectedVideo, ...prevTracks]);
        //   setCurrentMainVideos(allVideos?.slice(0, 3));
        //   setSelectedVideo();
        // }
        if (
          document
            ?.getElementById("fullScreenVideo")
            ?.classList?.contains("fullscreen")
        ) {
          toggleFullScreenVideo();
          setSelectedVideo();
        }
      } else {
        console.error("Invalid video track for user:", user);
      }
    }

    if (mediaType === "audio") {
      const remoteAudioTrack = await client?.subscribe(user, mediaType);
      if (remoteAudioTrack) {
        setRemoteUserAudioTracks((prevTracks) => [
          ...prevTracks,
          { user, audio: remoteAudioTrack },
        ]);
        remoteAudioTrack?.play();
      } else {
        console.error("Invalid audio track for user:", user);
      }

      if (mutedUsers[user.uid]) {
        remoteAudioTrack?.setVolume(0);
      } else {
        remoteAudioTrack?.setVolume(100);
      }
    }
  };

  const onUserUnpublish = async (user, mediaType) => {
    if (mediaType === "video") {
      const metadata = await getUserMetadata(String(user?.uid));
      const userWithMetadata = {
        user: user,
        metadata: metadata,
      };
      setRemoteUserTracks((prevTracks) =>
        prevTracks?.filter((trackInfo) => trackInfo?.user?.uid !== user?.uid)
      );
      // setAllVideos((prevTracks) =>
      //   prevTracks?.filter((trackInfo) => trackInfo?.user?.uid !== user?.uid)
      // );
      setJoinedUsersWithNoPublish((prevTracks) => [
        ...prevTracks,
        userWithMetadata,
      ]);
      if (
        document
          ?.getElementById("fullScreenVideo")
          ?.classList?.contains("fullscreen")
      ) {
        toggleFullScreenVideo();
        setSelectedVideo();
      }
    }
    if (mediaType === "audio") {
      setRemoteUserAudioTracks((prevTracks) =>
        prevTracks?.filter((trackInfo) => trackInfo?.user?.uid !== user?.uid)
      );
    }
  };

  const startScreenShare = async () => {
    try {
      if (videoTrack) {
        await client.unpublish(videoTrack);
        await turnOnCamera(false);
        setIsVideoPubed(false);
      }
      stream = await navigator.mediaDevices.getDisplayMedia({
        video: {
          width: { ideal: 1280 },
          height: { ideal: 720 },
        },
      });
      screenShareTrack = AgoraRTC.createCustomVideoTrack({
        mediaStreamTrack: stream.getVideoTracks()[0],
        encoderConfig: "720p_3",
        optimizationMode: "motion",
      });
      setTurnOnSahreScreenLoading(true);
      setIsVideoOn(false);
      await client.publish(screenShareTrack);
      setIsScreenVideoPubed(true);
      setTurnOnSahreScreenLoading(false);
    } catch (error) {
      if (error.name === "NotAllowedError" || error.name === "AbortError") {
        // console.log("Screen sharing cancelled");
      } else if (
        error.name === "NotFoundError" ||
        error.name === "NotReadableError"
      ) {
        errorToaster("Error accessing media devices on mobile");
      } else {
        errorToaster("Error starting screen share");
      }
    }
  };

  const stopScreenShare = async () => {
    try {
      setTurnOffSahreScreenLoading(true);
      screenShareTrack.stop();
      stream.getTracks().forEach((track) => track.stop());
      await client.unpublish(screenShareTrack);
      setIsScreenVideoPubed(false);
      screenShareTrack = null;
      stream = null;
      setTurnOffSahreScreenLoading(false);
    } catch (error) {
      setTurnOffSahreScreenLoading(true);
      screenShareTrack?.stop();
      stream?.getTracks()?.forEach((track) => track?.stop());
      setIsScreenVideoPubed(false);
      screenShareTrack = null;
      stream = null;
      setTurnOffSahreScreenLoading(false);
    }
  };

  const RaiseHand = async () => {
    const payload = {
      type: "raise-hand-request",
      message: "raise-your-hand",
      uid: String(config?.userId),
    };
    const publishMessage = { text: JSON.stringify(payload) };
    try {
      setIsHandRaised(true);
      await channel.sendMessage(publishMessage);
    } catch (error) {
      setIsHandRaised(false);
      console.log(error);
    }
  };

  const PutHandDown = async () => {
    const payload = {
      type: "raise-hand-request",
      message: "lower-your-hand",
      uid: String(config?.userId),
    };
    const publishMessage = { text: JSON.stringify(payload) };
    try {
      setIsHandRaised(false);
      await channel.sendMessage(publishMessage);
    } catch (error) {
      setIsHandRaised(true);
      console.log(error);
    }
  };

  const toggleUserMute = async (uid) => {
    setMutedUsers((prevMutedUsers) => {
      const newMutedUsers = { ...prevMutedUsers };
      newMutedUsers[uid] = !newMutedUsers[uid];
      return newMutedUsers;
    });
    await adjustUserMute(uid, !mutedUsers[uid]);
  };

  const adjustUserMute = async (uid, muted) => {
    const remoteUser = client.remoteUsers.find((user) => user.uid === uid);

    if (remoteUser) {
      const remoteAudioTrack = remoteUser.audioTrack;

      if (remoteAudioTrack) {
        if (muted) {
          remoteAudioTrack.setVolume(0);
        } else {
          remoteAudioTrack.setVolume(100);
        }
      }
    }
  };

  const toggleFullScreen = () => {
    const videoContainer = document.getElementById("videos");
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      if (videoContainer.requestFullscreen) {
        videoContainer.requestFullscreen();
      } else if (videoContainer.mozRequestFullScreen) {
        videoContainer.mozRequestFullScreen();
      } else if (videoContainer.webkitRequestFullscreen) {
        videoContainer.webkitRequestFullscreen();
      } else if (videoContainer.msRequestFullscreen) {
        videoContainer.msRequestFullscreen();
      }
      setIsFullScreen(true);
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
      setIsFullScreen(false);
    }
  };

  const onUserJoined = async (user) => {
    const metadata = await getUserMetadata(String(user?.uid));
    const userWithMetadata = {
      user: user,
      metadata: metadata,
    };
    setJoinedUsersWithNoPublish((prevTracks) => [
      ...prevTracks,
      userWithMetadata,
    ]);
  };

  const onUserLeft = (user) => {
    setJoinedUsersWithNoPublish((prevTracks) =>
      prevTracks?.filter((trackInfo) => trackInfo?.user?.uid !== user?.uid)
    );
  };

  const toggleFullScreenVideo = () => {
    document.getElementById("fullScreenVideo").classList.toggle("fullscreen");
  };

  const peerToPeerMessageHandler = async (message) => {
    if (message?.text == "video-mute") {
      setTurnOffCameraLoading(true);
      await turnOnCamera(false);
      setIsVideoPubed(false);
      setIsVideoOn(false);
      setTurnOffCameraLoading(false);
    } else if (message?.text == "audio-mute") {
      setTurnOffMicLoading(true);
      await turnOnMicrophone(false);
      setIsAudioPubed(false);
      setTurnOffMicLoading(false);
    } else if (message?.text == "share-screen-off") {
      stopScreenShare();
    } else if (message?.text == "leave-session") {
      leaveChannel();
    } else if (message?.text == "put-your-hand-down") {
      setIsHandRaised(false);
    }
  };

  const channelMessageHandler = async (message) => {
    if (message?.text == "leave-session") {
      leaveChannel();
    }
  };

  useEffect(() => {
    client.on("user-published", onUserPublish);
    client.on("user-unpublished", onUserUnpublish);
    client.on("user-joined", onUserJoined);
    client.on("user-left", onUserLeft);

    return () => {
      client.off("user-published", onUserPublish);
      client.off("user-unpublished", onUserUnpublish);
      client.off("user-joined", onUserJoined);
      client.off("user-left", onUserLeft);
    };
  }, []);

  useEffect(() => {
    signalingEngine?.on("MessageFromPeer", peerToPeerMessageHandler);
  }, [signalingEngine]);

  useEffect(() => {
    channel?.on("ChannelMessage", channelMessageHandler);
  }, [channel]);

  useEffect(() => {
    setUsersCount(
      joinedUsersWithNoPublish?.length + remoteUserTracks?.length + 1
    );
  }, [joinedUsersWithNoPublish]);

  useEffect(() => {
    setAllVideos(remoteUserTracks);
    setCurrentMainVideos(remoteUserTracks.slice(0, 3));
  }, [remoteUserTracks]);

  useEffect(() => {
    if (
      TurnOffCameraLoading ||
      TurnOffMicLoading ||
      turnOffSahreScreenLoading
    ) {
      document?.getElementById("fullScreenLoading")?.classList?.add("show");
    } else {
      setTimeout(
        function () {
          document
            ?.getElementById("fullScreenLoading")
            ?.classList?.remove("show");
        },
        [1000]
      );
    }
  }, [TurnOffCameraLoading, TurnOffMicLoading, turnOffSahreScreenLoading]);

  useEffect(() => {
    if (TurnOnCameraLoading || TurnOnMicLoading || turnOnSahreScreenLoading) {
      document?.getElementById("fullScreenLoading")?.classList?.add("show");
    } else {
      setTimeout(
        function () {
          document
            ?.getElementById("fullScreenLoading")
            ?.classList?.remove("show");
        },
        [2000]
      );
    }
  }, [TurnOnCameraLoading, TurnOnMicLoading, turnOnSahreScreenLoading]);

  useEffect(() => {
    if (isHandRaised) {
      let intervalId;
      let seconds = 0;
      const checkState = () => {
        seconds++;
        if (seconds >= 10) {
          setIsHandRaised(false);
          PutHandDown();
          clearInterval(intervalId);
        }
        if (!isHandRaised) {
          clearInterval(intervalId);
        }
      };
      intervalId = setInterval(checkState, 1000);
      return () => clearInterval(intervalId);
    }
  }, [isHandRaised]);

  // useEffect(() => {
  //   if (selectedVideo) {
  //     setAllVideos(allVideos?.filter((video) => video !== selectedVideo));
  //     setCurrentMainVideos(
  //       currentMainVideos?.filter((video) => video !== selectedVideo)
  //     );
  //     toggleFullScreenVideo();
  //   } else {
  //     setAllVideos((prevTracks) => [selectedVideo, ...prevTracks]);
  //     setCurrentMainVideos(remoteUserTracks?.slice(0, 3));
  //     toggleFullScreenVideo();
  //   }
  // }, [selectedVideo, allVideos, currentMainVideos]);

  return (
    <Styles usersCount={usersCount}>
      {isLoading ? (
        <div className="waiting">
          <Loader paddingTop={"20%"} />
        </div>
      ) : !isJoined ? (
        <>
          <SiteNavbar initBG={true} />
          <div>
            <Join
              courseId={courseId}
              id={id}
              joinChannel={joinChannel}
              isJoined={isJoined}
              isLoading={isLoading}
              data={data}
              isCourseDataLoading={isCourseDataLoading}
              isActivity={isActivity}
            />
          </div>
        </>
      ) : bigBlueButtonUrl ? (
        <BigBlueButtonMeeting bigBlueButtonUrl={bigBlueButtonUrl} />
      ) : (
        <Metting
          isJoined={isJoined}
          leaveChannel={leaveChannel}
          isFullScreen={isFullScreen}
          toggleFullScreen={toggleFullScreen}
          isScreenVideoPubed={isScreenVideoPubed}
          canPublishVideo={canPublishVideo}
          startScreenShare={startScreenShare}
          stopScreenShare={stopScreenShare}
          isAudioPubed={isAudioPubed}
          canPublishAudio={canPublishAudio}
          isVideoPubed={isVideoPubed}
          publishVideo={publishVideo}
          isLoading={isLoading}
          mutedUsers={mutedUsers}
          toggleUserMute={toggleUserMute}
          remoteUserAudioTracks={remoteUserAudioTracks}
          currentMainVideos={currentMainVideos}
          publishAudio={publishAudio}
          joinedUsersWithNoPublish={joinedUsersWithNoPublish}
          handleVideoClick={handleVideoClick}
          allVideos={allVideos}
          swiperRef={swiperRef}
          usersCount={usersCount}
          toggleFullScreenVideo={toggleFullScreenVideo}
          setCurrentMainVideos={setCurrentMainVideos}
          setAllVideos={setAllVideos}
          setSelectedVideo={setSelectedVideo}
          isVideoOn={isVideoOn}
          selectedVideo={selectedVideo}
          remoteUserTracks={remoteUserTracks}
          config={config}
          TurnOffMicLoading={TurnOffMicLoading}
          TurnOnMicLoading={TurnOnMicLoading}
          TurnOffCameraLoading={TurnOffCameraLoading}
          TurnOnCameraLoading={TurnOnCameraLoading}
          turnOnSahreScreenLoading={turnOnSahreScreenLoading}
          turnOffSahreScreenLoading={turnOffSahreScreenLoading}
          isAudience={isAudience}
          isHandRaised={isHandRaised}
          RaiseHand={RaiseHand}
          PutHandDown={PutHandDown}
        />
      )}
    </Styles>
  );
};

export default BbbTest;
